module.exports = __webpack_public_path__ + "img/1.be48421e.jpg";